import React from "react";
import ShopBanner from "./ShopBanner";
import Products from "./Products";

export default function Shop() {

  return (
    <React.Fragment>
      <ShopBanner />
      <Products />
    </React.Fragment>
  );
}
